









import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component, Prop, Watch} from "vue-property-decorator";
import {AuthStore} from "@/modules/auth/store";

@Component({
    name: "NotificationDetailCustomer"
})
export default class extends mixins(CommonMixin) {
    @Prop() id!: any;
    notification = null;

    created() {
        if (this.id) {
            this.singleNotification(this.id);
        }
    }

    get meta() {
        return AuthStore.listNotificationMeta;
    }

    @Watch('id')
    onchangeId(val: any) {
        if (!val) return;
        this.singleNotification(val);
    }
    async singleNotification(id: any) {
        try {
            this.notification = await AuthStore.singleNotification(id);
        } catch (e) {
            this.$message.error(e?.response?.data?.message || 'Đã xảy ra lỗi r');
        }
    }
}
